import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export default function CalendarPage() {
  const [cursor, setCursor] = useState(new Date());
  const [logs, setLogs] = useState([]);

  useEffect(() => { api.get("/logs").then(r => setLogs(r.data)); }, []);
  const byDate = useMemo(() => Object.fromEntries(logs.map(l => [l.log_date, l])), [logs]);

  const y = cursor.getFullYear(), m = cursor.getMonth();
  const first = new Date(y, m, 1);
  const startDow = first.getDay();
  const days = new Date(y, m + 1, 0).getDate();
  const cells = Array.from({ length: startDow + days }, (_, i) => i < startDow ? null : i - startDow + 1);

  const move = (delta) => setCursor(new Date(y, m + delta, 1));
  const monthLabel = cursor.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });

  return (
    <div data-testid="calendar-page" className="space-y-6">
      <header className="flex items-center justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Calendar</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">{monthLabel}</h1>
        </div>
        <div className="flex gap-2">
          <button data-testid="cal-prev" onClick={()=>move(-1)} className="p-2 rounded-full border border-slate-200 hover:bg-slate-50"><CaretLeft/></button>
          <button data-testid="cal-next" onClick={()=>move(1)} className="p-2 rounded-full border border-slate-200 hover:bg-slate-50"><CaretRight/></button>
        </div>
      </header>
      <div className="grid grid-cols-7 gap-1 text-xs text-slate-500">
        {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => <div key={d} className="px-3 py-2">{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => {
          if (!d) return <div key={`blank-${y}-${m}-${i}`} className="h-24" />;
          const ds = `${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
          const log = byDate[ds];
          const kinds = new Set((log?.subentries || []).map(s => s.kind));
          return (
            <Link key={ds} to={`/log?date=${ds}`} data-testid={`cal-day-${ds}`} className="h-24 rounded-xl border border-slate-200/70 p-2 bg-white hover:bg-slate-50 flex flex-col">
              <div className="text-sm font-semibold">{d}</div>
              <div className="mt-auto flex flex-wrap gap-1">
                {[...kinds].slice(0,5).map(k => <span key={k} className={`w-2 h-2 rounded-full k-${k}`} title={k} />)}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
